import React, { useEffect } from "react";
import getTranslationData from "../../TranslationUtility/TranslationUtility";
import { trackEvent } from "../Utility/Utility";

const TrendingCardHeader = ({
  product,
  categoryName,
  isToggle,
  trendingheading,
  totalCount
}) => {
  const translation = getTranslationData();
  // Filtered count: only products with valid priceDenomination
  const validProductsCount =
    product?.length || 0;
  return (
    <>
      <div className="col-12 p-trend">
        <h3 className="fill2">
          {isToggle
            ? trendingheading
            : categoryName.length === 1
              ? `${categoryName[0]} ${translation?.products}`
              : translation?.products}
        </h3>
        <p className="showing">
          <span className="showing-text">{translation?.showing}</span> <span className="validCount">{validProductsCount} </span> <span className="outOf">{product?.length === 0 ? translation?.results : "out of"} {totalCount} </span>
          <span className="totalCount">{translation?.items}</span>
        </p>
        {/* <p className="showing">
          {translation?.showing} {validProductsCount} {product?.length === 0 ? translation?.results : "results"}
        </p> */}
      </div>
    </>
  );
};

export default TrendingCardHeader;
